const staffPaths = new Set([
  "/admin/kitchen",
  "/admin/pos",
  "/admin/preorders",
  "/admin/dashboard",
  "/settings",
  "/orders",
]);

/** Accept only known local staff pages; never follow an external or public token-bearing redirect. */
export function loginDestination(value: string | null): string {
  if (!value || !staffPaths.has(value.split(/[?#]/)[0] ?? ""))
    return "/admin/kitchen";
  // A fragment can carry a one-time credential. Only retain the staff path and query.
  return value.split("#")[0] ?? "/admin/kitchen";
}
